export const scrollToTop = () => {
  const topBtn = document.querySelector('.js-scroll-top-btn');
  if (!topBtn) return;

  topBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};

export default scrollToTop;
